"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Select_1 = __importDefault(require("@material-ui/core/Select"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const LibraryAddCheckOutlined_1 = __importDefault(require("@material-ui/icons/LibraryAddCheckOutlined"));
const text_field_1 = require("../text-field/text-field");
const auto_focus_hook_1 = require("../../utils/auto-focus-hook");
const empty_component_1 = require("../../utils/empty-component");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const select_styles_1 = require("./select-styles");
/**
 * todo: add loadDetail call also to multiple select
 *
 */
function Select({ form, autoFocus, disabled, source, value, onChange, showTooltip = false, valueIsId = false, multiple = false, clearable = true, selectableAll = true, idMapper = (option) => option.id, labelMapper = (option) => option.name, tooltipMapper = (option) => option.tooltip, DisabledComponent = text_field_1.TextField, }) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleOpen = (0, event_callback_hook_1.useEventCallback)(() => {
        setOpen(true);
    });
    const handleClose = (0, event_callback_hook_1.useEventCallback)(() => {
        setOpen(false);
    });
    const { autoFocusRef } = (0, auto_focus_hook_1.useAutoFocus)(autoFocus, disabled);
    const valueToId = (0, event_callback_hook_1.useEventCallback)((value) => {
        return valueIsId ? value : idMapper(value);
    });
    const valuesToIds = (0, event_callback_hook_1.useEventCallback)((values) => {
        return values.map((value) => valueToId(value));
    });
    // in some cases the value is not included in the options, adds it at the end
    const options = (0, react_1.useMemo)(() => {
        if (value && !valueIsId) {
            if (multiple) {
                return (0, lodash_1.uniqBy)([...source.items, ...value], valueToId);
            }
            else {
                return (0, lodash_1.uniqBy)([...source.items, value], valueToId);
            }
        }
        else {
            return source.items;
        }
    }, [value, source, multiple, valueIsId, valueToId]);
    const idToValue = (0, event_callback_hook_1.useEventCallback)((id) => {
        return valueIsId ? id : options.find((option) => idMapper(option) === id);
    });
    const idsToValues = (0, event_callback_hook_1.useEventCallback)((ids) => {
        return ids.map((id) => idToValue(id));
    });
    const handleChange = (0, event_callback_hook_1.useEventCallback)(async (e) => {
        const ids = e.target.value;
        let values;
        if (ids === undefined || ids === '') {
            values = null;
        }
        else if (multiple) {
            values = idsToValues(ids);
        }
        else {
            values = idToValue(ids);
            if (!valueIsId) {
                values = await source.loadDetail(values);
            }
        }
        onChange(values);
    });
    const handleClear = (0, event_callback_hook_1.useEventCallback)(() => {
        onChange(null);
    });
    const handleSelectAll = (0, event_callback_hook_1.useEventCallback)(() => {
        const ids = source.items.map((item) => item.id);
        const values = idsToValues(ids);
        onChange(values);
    });
    function getLocalValue(value) {
        if (value === null) {
            return multiple ? [] : '';
        }
        const optionIds = options.map((option) => idMapper(option));
        if (multiple) {
            const ids = valuesToIds(value);
            return ids.filter((id) => optionIds.includes(id));
        }
        else {
            const id = valueToId(value);
            return optionIds.includes(id) ? id : '';
        }
    }
    const { root, input, list, item, icon, iconOpened, select } = (0, select_styles_1.useStyles)();
    const showSelectAllButton = selectableAll && multiple && !disabled;
    const showClearButton = clearable && !disabled && value !== null;
    const RenderFunc = (0, react_1.useCallback)((val, Component = text_field_1.TextField) => {
        let label = '';
        if (multiple) {
            const ids = val;
            label = ids
                .map((id) => options.find((option) => option.id === id))
                .map((option) => option && labelMapper(option))
                .join(', ');
        }
        else {
            const id = val;
            const option = options.find((option) => option.id === id);
            label = option !== undefined ? labelMapper(option) : '';
        }
        return (react_1.default.createElement(Component, { disabled: disabled, showClearButton: false, value: label }));
    }, [disabled, labelMapper, multiple, options]);
    return (react_1.default.createElement(react_1.default.Fragment, null, disabled ? (react_1.default.createElement(react_1.default.Fragment, null, RenderFunc(getLocalValue(value), DisabledComponent))) : (react_1.default.createElement(Select_1.default, { open: open, onClose: handleClose, onOpen: handleOpen, endAdornment: react_1.default.createElement(InputAdornment_1.default, { position: "end" },
            showSelectAllButton && (react_1.default.createElement(IconButton_1.default, { size: "small", onClick: handleSelectAll, className: icon },
                react_1.default.createElement(LibraryAddCheckOutlined_1.default, { fontSize: "small" }))),
            showClearButton && (react_1.default.createElement(IconButton_1.default, { size: "small", onClick: handleClear, className: icon, tabIndex: -1 },
                react_1.default.createElement(Clear_1.default, { fontSize: "small" }))),
            react_1.default.createElement(IconButton_1.default, { size: "small", onClick: () => setOpen(!open), classes: {
                    root: (0, clsx_1.default)(icon, { [iconOpened]: open }),
                } },
                react_1.default.createElement(ArrowDropDown_1.default, { fontSize: "small" }))), inputProps: {
            form,
        }, SelectDisplayProps: {
            'data-cy': 'EAS__SELECT',
        }, MenuProps: {
            classes: { list },
            anchorOrigin: {
                horizontal: 'left',
                vertical: 'bottom',
            },
            getContentAnchorEl: null,
            PaperProps: {
                'data-cy': 'EAS__SELECT_MENU',
            },
        }, IconComponent: empty_component_1.EmptyComponent, inputRef: autoFocusRef, className: input, classes: {
            root,
            select,
        }, disabled: disabled, multiple: multiple, value: getLocalValue(value), onChange: handleChange, autoWidth: true, renderValue: RenderFunc }, options.map((option) => (react_1.default.createElement(MenuItem_1.default, { key: idMapper(option), value: idMapper(option), classes: { root: item } }, showTooltip ? (react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement(react_1.default.Fragment, null, tooltipMapper(option)) },
        react_1.default.createElement(react_1.default.Fragment, null, labelMapper(option)))) : (labelMapper(option)))))))));
}
exports.Select = Select;
//# sourceMappingURL=select.js.map